import { default as MuiInputLabel, InputLabelProps } from '@mui/material/InputLabel'
import React from 'react'

import { createComponentWrapperWithRef, styled } from '../../theme'
import { COLORS } from '../../theme/colors'
import { MsdkStyledComponent } from '../../utils'

type MsdkFormFieldLabel = InputLabelProps & {
  filterField?: boolean
  hasEndAdornment?: boolean
  children?: React.ReactNode
}

const MuiFormFieldLabel: MsdkStyledComponent<MsdkFormFieldLabel> = styled(MuiInputLabel, {
  shouldForwardProp: (prop) => prop !== 'filterField' && prop !== 'hasEndAdornment',
})<{
  filterField?: boolean
  hasEndAdornment?: boolean
}>`
  &.Mui-focused,
  &.MuiFormLabel-filled {
    padding-right: ${({ filterField }) => {
      if (!filterField) return '24px;'
      return '0;'
    }};
  }

  color: ${COLORS.text.secondary};
  padding: 0;
  padding-right: ${({ filterField, hasEndAdornment }) => {
    if (!filterField && !hasEndAdornment) return '16px;'
    if (filterField && hasEndAdornment) return '16px;'
    if (hasEndAdornment) return '32px;'
    return '0;'
  }};
`
const StyledFormFieldLabel = createComponentWrapperWithRef<MsdkFormFieldLabel>(
  {
    mui: MuiFormFieldLabel,
    nova: MuiFormFieldLabel,
  },
  'FormFieldLabel',
)

const FormFieldLabelText = createComponentWrapperWithRef(
  {
    mui: styled('span')({}),
    nova: styled('span')({
      '.MuiInputLabel-root:not(.MuiInputLabel-shrink) &': {
        flex: '0 1 auto',
        minWidth: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: 'calc(100% - 1em)',
      },
    }),
  },
  'FormFieldLabelText',
)

export function FormFieldLabel({ ...props }: MsdkFormFieldLabel) {
  return (
    <StyledFormFieldLabel {...props}>
      <FormFieldLabelText>{props?.children}</FormFieldLabelText>
    </StyledFormFieldLabel>
  )
}
